import { useQuery } from '@tanstack/react-query';

import { RequestConfig } from '~/common/services/requests/types/RequestConfig';
import { Recipient } from '../../../../types';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { SIGNATURE_BASE_PATH } from '../../constants/signatureBasePath';
import { getSignatureRecipient } from '../../requests/getSignatureRecipient';

export const useSignatureRecipient = (
  params: RequestConfig['params'],
  options?: { enabled?: boolean },
) => {
  const { constructGet } = useRequestConstructor();

  const { data, ...rest } = useQuery<
    NonPaginatedResponse<Recipient> | undefined
  >({
    queryKey: [SIGNATURE_BASE_PATH, 'recipient', params],
    queryFn: () => getSignatureRecipient(constructGet, params),
    staleTime: 10000,
    ...options,
  });

  return { recipient: data?.data, ...rest };
};
